module.exports = __webpack_public_path__ + "img/mb3-t2.4edd43f8.png";